import React from "react";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
    <div>
      <div className="overline text-[#00857C] mb-1">Consignment Platform</div>
      <h1 data-testid="page-title" className="font-head text-2xl font-bold text-[#0B2545]">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
);

export const Panel = ({ title, children, className = "" }) => (
  <div className={`bg-white border border-slate-200 rounded-sm ${className}`}>
    {title && <div className="px-4 py-3 border-b border-slate-100 font-head font-semibold text-sm text-[#0B2545]">{title}</div>}
    <div className="p-4">{children}</div>
  </div>
);

const STATUS_COLORS = {
  in_bin: "#0B2545", in_transit: "#b45309", in_transit_to_regional: "#ca8a04", at_regional: "#00857C", in_transit_to_site: "#ca8a04", at_site: "#0369a1",
  installed: "#7c3aed", active: "#16a34a", return_in_transit: "#b45309", returned: "#6b7280", written_off: "#dc2626",
  pending: "#b45309", dispatched: "#ca8a04", received: "#16a34a", partial: "#c2410c", fulfilled: "#16a34a", closed: "#6b7280",
};

export const StatusBadge = ({ status }) => {
  const c = STATUS_COLORS[status] || "#6b7280";
  const label = String(status || "").replace(/_/g, " ");
  return (
    <span className="px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-wide" style={{ background: `${c}1a`, color: c }}>
      {label}
    </span>
  );
};

export const Empty = ({ children }) => (
  <div className="text-center text-sm text-slate-400 py-10">{children}</div>
);

export const Select = ({ value, onChange, options, placeholder, testid }) => (
  <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
    className="border border-slate-200 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00857C] bg-white">
    <option value="">{placeholder || "Select…"}</option>
    {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);
